import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/map/rotateMobile.png';
const _hoisted_1 = {
  class: "promptBox",
  id: "promptBox"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1), _createElementVNode("p", null, "为了更好的体验，请开启微信横屏设置", -1), _createElementVNode("span", null, "我知道了", -1)]));
}